import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../../../config/ApiConfig';

/**
 * Hook para verificar situação de programas (vigente/encerrado)
 * @returns {Object} - { programasMap, isProgramaAtivo, verificarProgramaAtivo, carregando }
 */
function useProgramaSituacao() {
  const [programasMap, setProgramasMap] = useState({});
  const [carregando, setCarregando] = useState(true);
  const token = localStorage.getItem('token');
  const cnpj = localStorage.getItem('cnpj');

  useEffect(() => {
    if (!token || !cnpj) return;

    setCarregando(true);
    axios
      .get(`${API_BASE_URL.PROGRAMA}/all`, {
        params: { cnpjAssociacao: cnpj },
        headers: { Authorization: `Bearer ${token}` },
      })
      .then(result => {
        const programas = Array.isArray(result.data) ? result.data : [];
        const map = {};
        programas.forEach(prog => {
          // ATIVO apenas se situacao === true explicitamente
          map[prog.id] = prog.situacao === true;
        });
        setProgramasMap(map);
        setCarregando(false);
      })
      .catch(error => {
        console.error('Erro ao buscar programas:', error);
        setCarregando(false);
      });
  }, [token, cnpj]);

  /**
   * Verifica se um programa está vigente
   * @param {number|string} idPrograma - ID do programa a verificar
   * @returns {boolean} - true se vigente, false se encerrado
   */
  const isProgramaAtivo = useCallback(idPrograma => {
    if (!idPrograma) return true; // Se não tem programa, permite ação
    // IMPORTANTE: Se o programa não está no map, considera ENCERRADO por segurança
    if (!(idPrograma in programasMap)) return false;
    return programasMap[idPrograma] === true;
  }, [programasMap]);

  /**
   * Verifica se um programa está vigente com mensagem opcional
   * @param {number|string} idPrograma - ID do programa a verificar
   * @param {boolean} showMessage - Se deve retornar mensagem de erro
   * @returns {boolean|Object} - true/false ou { ativo: boolean, mensagem: string }
   */
  const verificarProgramaAtivo = (idPrograma, showMessage = false) => {
    const ativo = isProgramaAtivo(idPrograma);
    
    if (showMessage) {
      return {
        ativo,
        mensagem: ativo ? '' : 'Este programa está ENCERRADO. Não é possível criar/editar/excluir registros.'
      };
    }
    
    return ativo;
  };

  return {
    programasMap,
    isProgramaAtivo,
    verificarProgramaAtivo,
    carregando
  };
}

export default useProgramaSituacao;
